import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API functions for user document management
export const userApi = {
  // Upload user document
  uploadDocument: async (userId, file, documentType) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('document_type', documentType);
    
    const response = await api.post(`/api/users/${userId}/upload-document`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete user document
  deleteDocument: async (userId, fileUrl) => {
    const formData = new FormData();
    formData.append('file_url', fileUrl);
    
    const response = await api.delete(`/api/users/${userId}/documents`, {
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update user profile
  updateProfile: async (userId, updateData) => {
    const response = await api.put(`/api/users/${userId}`, updateData);
    return response.data;
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await api.get('/api/auth/me');
    return response.data;
  },
};

// Export the configured axios instance as default
export default api;